<template>
  <section id="challenge-setup" class="text-white d-flex flex-column">
    <div class="commet-background flex-fill pt-4 pb-5 px-4 d-flex flex-column">
      <SectionTitleHeader :title="title" color="general-knowledge" class="pt-5 mb-5" />
      <main class="d-flex flex-column justify-content-center align-items-center mb-5" data-aos="zoom-in" data-aos-delay="1000">
        <img alt="Challenge Mode Image" :src="challengeModeIcon" width="242" height="172" />
        <p class="font-italic legend --big">{{ description }}</p>
      </main>
      <div class="d-flex justify-content-space-between">
        <button type="button" class="btn bg-green-neon flex-fill rounded-button" data-aos="fade-left" data-aos-offset="-100" data-aos-delay="500" @click="action">
          {{ CTA }}
        </button>
      </div>
    </div>
  </section>
</template>
<script>
import SectionTitleHeader from '@/components/SectionTitleHeader.vue';
import alexa from '@/utils/alexa';
import mixpanel from 'mixpanel-browser';

export default {
  components: { SectionTitleHeader },
  methods: {
    action() {
      const action = this.$route.meta.as === 'host' ? 'resumeChallenge' : 'joinChallenge';
      alexa.callIntent(action, this.$route.params.id);
    },
    sendEvent(action, properties) {
      try {
        console.log(action, properties);
        const data = { action: action, ...properties };
        console.log('challenge_page_done_event', data);
        mixpanel.track('challenge_page_done_event', data);
      } catch (e) {
        console.error(e);
      }
    }
  },
  computed: {
    challengeModeIcon() {
      return require('@/assets/images/swords.png');
    },
    description() {
      return this.$t('message.click-to-create-the-game');
    },
    title() {
      return this.$route.meta.as == 'host' ? this.$t('message.challenge-created') : this.$t('message.joined-challenge');
    },
    CTA() {
      return this.$t('message.start-game');
    }
  },
  mounted() {
    if (!this.$store.state.challenge.session_data) {
      return this.$router.push({ name: 'challenge-' + this.$route.meta.as, params: this.$route.params });
    }
    const id = this.$route.params.id;
    const as = this.$route.meta.as;
    try {
      mixpanel.init('e4cc2959721dc3dca351dc9f7ae2ed7a');
      mixpanel.identify(as + '-' + id);
      this.sendEvent('page_visited', { as: as });
    } catch (e) {
      console.error(e);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/assets/custom-vars/_colors.scss';

#challenge-setup {
  background: $gradient-challenge-mode;
  box-shadow: -5px 0px 10px rgba(0, 0, 0, 0.4);
  min-height: 100%;
  main {
    flex-grow: 2;
  }
  button.--outlined {
    border-color: $green-neon;
  }
}
</style>
